module.exports = __webpack_public_path__ + "img/file-lock-03.c10efaf6.svg";